import React from 'react';
import _ from 'underscore';

import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { SessionManagementService } from '~src/sessionManagement/SessionManagementService';
import { MobileSettingsSubspaceState } from '~src/settings/mobile-settings/MobileSettingsSubspaceShared';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';


interface MobileSiteSettingsSubspaceOwnProps {
  readonly siteName: string;
  readonly urls: SpacesSiteUrls;
  readonly server: SessionManagementService;
  readonly isSessionMultiSite: boolean;
  readonly isSessionServerAdmin: boolean;
}

export class MobileSiteSettingsSubspaceComponent extends React.PureComponent<MobileSiteSettingsSubspaceOwnProps, MobileSettingsSubspaceState> {

  private unmounted: boolean = false;

  private initialState: MobileSettingsSubspaceState = {
    isServerPage: true,
    isMultiSite: undefined,
    hasDataToRender: false,
    hasError: false,
    siteSettingsForSiteAdmin: undefined,
  };

  public constructor(props: MobileSiteSettingsSubspaceOwnProps) {
    super(props);
    this.state = {
      ...this.initialState,
      isMultiSite: props.isSessionMultiSite
    };
  }

  public componentDidMount() {
    // getData(
    //   (newState) => { this.updateState(newState as MobileSettingsSubspaceState); },
    //   () => { this.updateState({hasError: true}); }
    // );
  }

  public componentWillUnmount() {
    this.unmounted = true;
  }

  public componentDidUpdate() {
    if ((!_.isUndefined(this.state.siteSettingsForSiteAdmin) || !FeatureFlags.mobileSecuritySettingsEnabled)
    ) {
      this.updateState({hasDataToRender: true});
    }
  }

  public render() {
  //   if (!this.state.hasDataToRender) {
  //     return null;
  //   } else if (this.state.hasError) {
  //     return <RouterError errorType={'server-default'} urls={undefined}/>;
  //   }

    return (
      <div>{'Hello world!!!'}</div>
    );
  }

  private updateState<K extends keyof MobileSettingsSubspaceState>(newState: Pick<MobileSettingsSubspaceState, K>, callback?: () => void): void {
    if (!this.unmounted) {
      this.setState(newState, callback);
    }
  }
}
